import * as _ from 'lodash';

/**
 * Conversions:
 * - Title Case
 * - AP Style Title Case
 * - UPPERCASE
 * - lowercase
 * - Start case
 * - camelCase
 * - PascalCase
 * - hyphen-case
 * - snake_case
 * - dot.case
 * - Sentence case
 **/
export enum TextConversionTypes {
  Title = 'Title',
  Upper = 'Upper',
  Lower = 'Lower',
  Start = 'Start',
  Camel = 'Camel',
  Pascal = 'Pascal',
  Hyphen = 'Hyphen',
  Snake = 'Snake',
  Dot = 'Dot',
  Sentence = 'Sentence',
  Unsnake = 'Unsnake',
}

export function convertText(
  value: string,
  conversion: TextConversionTypes | TextConversionTypes[],
): string {
  if (!Array.isArray(conversion)) {
    conversion = [conversion];
  }

  for (const item of conversion) {
    switch (item) {
      case TextConversionTypes.Title:
        value = value
          .split(' ')
          .map((p) => _.startCase(p))
          .join(' ');
        break;

      case TextConversionTypes.Upper:
        value = value.toUpperCase();
        break;

      case TextConversionTypes.Lower:
        value = value.toLowerCase();
        break;

      case TextConversionTypes.Start:
        value = _.startCase(value);
        break;

      case TextConversionTypes.Camel:
        value = _.camelCase(value);
        break;

      case TextConversionTypes.Pascal:
        value = value
          .split(' ')
          .map((p) => _.startCase(p))
          .join('');
        break;

      case TextConversionTypes.Hyphen:
        value = value.split(' ').join('-');
        break;

      case TextConversionTypes.Snake:
        value = value.split(' ').join('_');
        break;

      case TextConversionTypes.Dot:
        value = value.split(' ').join('.');
        break;

      case TextConversionTypes.Sentence:
        value = value.replace(/\_/g, ' ');
        value = value[0].toUpperCase() + value.substring(1);
        break;

      case TextConversionTypes.Unsnake:
        value = value.replace(/\_/g, ' ');
        break;
    }
  }

  return value;
}
